// Bilingual (EN / ZH) translation dictionary
export const translations = {
  en: {
    appName: "Ali Construction",
    appSub: "Engineering Project Management",
    login: "Sign In",
    username: "Username",
    password: "Password",
    loginBtn: "Sign In",
    loginError: "Invalid username or password",
    demoAccounts: "Demo Accounts",
    logout: "Log Out",
    // nav
    dashboard: "Dashboard",
    teamBoard: "Team Board",
    finance: "Finance",
    ceoBoard: "CEO Board",
    dataImport: "Data Import",
    reminders: "Reminders",
    // dashboard
    overview: "Company Overview",
    totalProjects: "Total Projects",
    activeTeams: "Active Teams",
    totalContract: "Total Contract Value",
    collected: "Collected",
    receivable: "Total Receivable",
    pendingCollection: "Pending Collection",
    projectsByPhase: "Projects by Phase",
    projectsByTeam: "Projects by Team",
    collectionProgress: "Collection Progress",
    teamComparison: "Construction Team Comparison",
    // board
    searchProjects: "Search by address, manager...",
    allTeams: "All Teams",
    manager: "Manager",
    contract: "Contract",
    startDate: "Start Date",
    progress: "Progress",
    transfer: "Transfer",
    transferTo: "Transfer project to team",
    moveStage: "Advance Stage",
    confirm: "Confirm",
    cancel: "Cancel",
    projectDetail: "Project Detail",
    paymentSchedule: "Payment Schedule",
    stage: "Stage",
    amount: "Amount",
    status: "Status",
    // finance
    financeTitle: "Finance & Collections",
    contractSetup: "Contract & Milestone Setup",
    totalContractAmount: "Total Contract Amount",
    milestoneRatio: "Milestone Ratios",
    receivableAging: "Receivables Overview",
    markInvoiced: "Send Invoice",
    markPaid: "Mark Paid",
    remind: "Remind Finance",
    // reminders
    remindersTitle: "Reminders",
    noReminders: "No pending reminders. All caught up!",
    reminderMsg: "Milestone completed — issue invoice to client",
    invoiceSent: "Invoice sent to client",
    paymentReceived: "Payment received & recorded",
    // import
    importTitle: "Data Import & Auto-Update",
    importDesc: "Upload the weekly Excel / CSV progress list to auto-update project stages.",
    dropFile: "Drag & drop Excel/CSV here, or click to browse",
    lastSync: "Last Sync",
    importPreview: "Import Preview",
    applyImport: "Apply Update",
    rowsDetected: "rows detected",
    // misc
    all: "All",
    project: "Project",
    completed: "Completed",
    inProgress: "In Progress",
    viewDetail: "View",
    close: "Close",
    save: "Save",
    updated: "Updated successfully",
    address: "Address",
    createProject: "New Project",
    projectType: "Project Type",
    clientName: "Client Name",
    phone: "Phone",
    email: "Email",
    assignTeam: "Assign to Team",
    salesperson: "Salesperson",
    customerService: "Customer Service",
    expectedStart: "Expected Start",
    expectedEnd: "Expected End",
    allTypes: "All Types",
    riskLevel: "Risk",
    filterBy: "Filter",
    keyword: "Keyword",
    created: "Project created",
    selectTeam: "Select team",
    selectType: "Select type",
    selectSales: "Select salesperson",
    selectCS: "Select customer service",
  },
  zh: {
    appName: "阿里建筑",
    appSub: "工程部项目管理平台",
    login: "登录",
    username: "用户名",
    password: "密码",
    loginBtn: "登录",
    loginError: "用户名或密码错误",
    demoAccounts: "演示账号",
    logout: "退出登录",
    dashboard: "总览看板",
    teamBoard: "工程项目",
    finance: "财务收款",
    ceoBoard: "CEO 看板",
    dataImport: "数据导入",
    reminders: "提醒中心",
    overview: "公司总览",
    totalProjects: "项目总数",
    activeTeams: "在建小组",
    totalContract: "合同总额",
    collected: "已收款",
    receivable: "应收总额",
    pendingCollection: "待收款",
    projectsByPhase: "各阶段项目分布",
    projectsByTeam: "各工程项目数",
    collectionProgress: "收款进度",
    teamComparison: "工程项目组对比",
    searchProjects: "按地址、负责人搜索...",
    allTeams: "全部小组",
    manager: "负责人",
    contract: "合同金额",
    startDate: "开工日期",
    progress: "进度",
    transfer: "转移",
    transferTo: "将项目转移至小组",
    moveStage: "推进阶段",
    confirm: "确认",
    cancel: "取消",
    projectDetail: "项目详情",
    paymentSchedule: "收款计划",
    stage: "阶段",
    amount: "金额",
    status: "状态",
    financeTitle: "财务与收款管理",
    contractSetup: "合同与节点设置",
    totalContractAmount: "合同总金额",
    milestoneRatio: "各节点收款比例",
    receivableAging: "应收款概览",
    markInvoiced: "发送收款单",
    markPaid: "标记已收款",
    remind: "提醒财务",
    remindersTitle: "提醒中心",
    noReminders: "暂无待处理提醒，一切妥当！",
    reminderMsg: "节点已完成 — 请向客户开具收款单",
    invoiceSent: "收款单已发送客户",
    paymentReceived: "收款完成并已记录",
    importTitle: "数据导入与自动更新",
    importDesc: "上传每周的 Excel / CSV 进度清单，自动更新项目阶段。",
    dropFile: "拖拽 Excel/CSV 到此处，或点击选择文件",
    lastSync: "上次同步",
    importPreview: "导入预览",
    applyImport: "应用更新",
    rowsDetected: "行数据已识别",
    all: "全部",
    project: "项目",
    completed: "已完成",
    inProgress: "进行中",
    viewDetail: "查看",
    close: "关闭",
    save: "保存",
    updated: "更新成功",
    address: "项目地址",
    createProject: "创建项目",
    projectType: "项目类型",
    clientName: "客户姓名",
    phone: "联系电话",
    email: "电子邮件",
    assignTeam: "分配到小组",
    salesperson: "销售人员",
    customerService: "客服人员",
    expectedStart: "预计开工时间",
    expectedEnd: "预计结束时间",
    allTypes: "全部类型",
    riskLevel: "风险",
    filterBy: "筛选",
    keyword: "关键词",
    created: "项目创建成功",
    selectTeam: "选择小组",
    selectType: "选择类型",
    selectSales: "选择销售",
    selectCS: "选择客服",
  },
  es: {
    appName: "Ali Construction",
    appSub: "Plataforma de gestión de proyectos de ingeniería",
    login: "Iniciar sesión",
    username: "Usuario",
    password: "Contraseña",
    loginBtn: "Iniciar sesión",
    loginError: "Usuario o contraseña incorrectos",
    demoAccounts: "Cuentas de demostración",
    logout: "Cerrar sesión",
    dashboard: "Panel general",
    teamBoard: "Proyectos de obra",
    finance: "Finanzas y cobros",
    ceoBoard: "Panel del CEO",
    dataImport: "Importar datos",
    reminders: "Notificaciones",
    overview: "Resumen de la empresa",
    totalProjects: "Total de proyectos",
    activeTeams: "Equipos activos",
    totalContract: "Valor total de contratos",
    collected: "Cobrado",
    receivable: "Total por cobrar",
    pendingCollection: "Pendiente de cobro",
    projectsByPhase: "Proyectos por fase",
    projectsByTeam: "Proyectos por equipo",
    collectionProgress: "Avance de cobros",
    teamComparison: "Comparación por equipo de ingeniería",
    searchProjects: "Buscar por dirección, responsable...",
    allTeams: "Todos los equipos",
    manager: "Responsable",
    contract: "Monto del contrato",
    startDate: "Fecha de inicio",
    progress: "Avance",
    transfer: "Transferir",
    transferTo: "Transferir proyecto al equipo",
    moveStage: "Avanzar fase",
    confirm: "Confirmar",
    cancel: "Cancelar",
    projectDetail: "Detalle del proyecto",
    paymentSchedule: "Calendario de pagos",
    stage: "Fase",
    amount: "Monto",
    status: "Estado",
    financeTitle: "Finanzas y cobros",
    contractSetup: "Contrato e hitos",
    totalContractAmount: "Monto total del contrato",
    milestoneRatio: "Porcentaje por hito",
    receivableAging: "Resumen de cuentas por cobrar",
    markInvoiced: "Enviar factura",
    markPaid: "Marcar como pagado",
    remind: "Avisar a finanzas",
    remindersTitle: "Notificaciones",
    noReminders: "No hay recordatorios pendientes. ¡Todo al día!",
    reminderMsg: "Hito completado — emitir factura al cliente",
    invoiceSent: "Factura enviada al cliente",
    paymentReceived: "Pago recibido y registrado",
    importTitle: "Importación de datos y actualización automática",
    importDesc: "Suba la lista semanal de avance en Excel / CSV para actualizar las fases de los proyectos.",
    dropFile: "Arrastre aquí el archivo Excel/CSV o haga clic para seleccionarlo",
    lastSync: "Última sincronización",
    importPreview: "Vista previa de importación",
    applyImport: "Aplicar actualización",
    rowsDetected: "filas detectadas",
    all: "Todos",
    project: "Proyecto",
    completed: "Completado",
    inProgress: "En curso",
    viewDetail: "Ver",
    close: "Cerrar",
    save: "Guardar",
    updated: "Actualizado correctamente",
    address: "Dirección del proyecto",
    createProject: "Nuevo proyecto",
    projectType: "Tipo de proyecto",
    clientName: "Nombre del cliente",
    phone: "Teléfono",
    email: "Correo electrónico",
    assignTeam: "Asignar al equipo",
    salesperson: "Vendedor",
    customerService: "Servicio al cliente",
    expectedStart: "Inicio previsto",
    expectedEnd: "Fin previsto",
    allTypes: "Todos los tipos",
    riskLevel: "Riesgo",
    filterBy: "Filtrar",
    keyword: "Palabra clave",
    created: "Proyecto creado",
    selectTeam: "Seleccione equipo",
    selectType: "Seleccione tipo",
    selectSales: "Seleccione vendedor",
    selectCS: "Seleccione servicio al cliente",
  },
};
